import {generarObjetoError, esFuncion} from './utils';
/**
 * Ejecuta las funciones de validacion definidas por `fnsValidacion` al valor `value`, usando `opciones` para configurar el comportamiento de las funcions y la condicion de pare de las validaciones
 * @param {any} value
 * @param {Function|Function[]} fnsValidacion Funcion que retorna un arreglo de funciones o el propio arreglo de funciones que toman como primer parametros a `value` y como segundo parametro un objeto de la forma {dependencias=`opciones.dependenciasFn`, resultadoAnterior:{existeError:boolean, msg:string, data:{}}} y deben retornar un objeto de la forma {existeError:boolean, msg:string, data:{}}. Donde el parametro de entrada __resultadoAnterior__ es el retorno de la funcion de validacion anterior
 * @param {Object} opciones
 * @param {{}|[]} opciones.dependenciasFn Variables enviadas como propiedad __dependencias__ del segundo parametro en las funciones definidas por `fnsValidacion` y a `fnsValidacion[].selectorFunciones` si existiera.
 * @param {boolean} opciones.stopOnError Si __true__, se ejecutar las funciones definidas por `fnsValidacion` solo hasta encontrar el primer error de validacion
 * @returns {{existeError:boolean, msg:string, data:{existeError: boolean, msg:string, data:Object}[]}} Objeto con el resultado de las validaciones aplicadas. __data__ contine la lista de errores epecificos por cada funcion de validacion que retorno existeError=__true__
 */
export function aplicarValidaciones(
   value,
   fnsValidacion,
   {dependenciasFn = {}, stopOnError = false} = {}
) {
   let resultadoValidacion = generarObjetoError('', []);
   let arregloFuncionesValidacion = fnsValidacion;
   if (!arregloFuncionesValidacion) {
      return resultadoValidacion;
   }
   //#region si funcionesValidacion es una funcion la ejecutamos para obtener el arreglo final de funciones de validacion
   if (esFuncion(arregloFuncionesValidacion)) {
      arregloFuncionesValidacion = arregloFuncionesValidacion(valor, {
         dependencias: dependenciasFn
      });
   }
   if (arregloFuncionesValidacion.length === 0) {
      return resultadoValidacion;
   }
   //#endregion
   let inxF = 0;
   let resultadoAnterior = {};
   while (
      !(resultadoValidacion.existeError && stopOnError) &&
      inxF < arregloFuncionesValidacion.length
   ) {
      let resultadoActual = generarObjetoError('');
      let fnValidacionActual = arregloFuncionesValidacion[inxF];
      //Determinar si es funcion o funcion condicional
      if (fnValidacionActual && esFuncion(fnValidacionActual.selectorFunciones)) {
         fnValidacionActual = fnValidacionActual.selectorFunciones(value, {
            dependencias: dependenciasFn,
            resultadoAnterior
         });
      }
      //Aplicar la validacion
      if (fnValidacionActual && esFuncion(fnValidacionActual)) {
         resultadoActual = fnValidacionActual(value, {
            dependencias: dependenciasFn,
            resultadoAnterior
         });
      }
      resultadoAnterior = {...resultadoActual};
      if (resultadoActual.existeError) {
         resultadoValidacion.existeError = true;
         resultadoValidacion.msg = 'Se encontraron errores al aplicar las validaciones';
         resultadoValidacion.data.push(resultadoActual);
      }
      //actualizar variables q controlan el bucle
      inxF++;
   }
   return resultadoValidacion;
}

export class Validador {
   /**
    * Create a point.
    * @param {number} reglasValidacion - The x value.
    */
   constructor(reglasValidacion) {
      this.reglas = reglasValidacion;
   }
   validarValor(value, key, {registro, stopOnError = false} = {}) {
      return aplicarValidaciones(value, this.reglas[key], {
         dependenciasFn: registro,
         stopOnError
      });
   }
   /**
    *
    * @param {{}|[]} registro
    * @param {{}} opciones
    */
   validarRegistro(
      registro,
      {stopOnError = false, ignoredKeys = [], onItemValidado = (resValidacion, key) => {}} = {}
   ) {
      const resValidacionRegistro = generarObjetoError('', []);
      for (const key in registro) {
         if (ignoredKeys.includes(key)) {
            continue;
         }
         const resValidacionItem = this.validarValor(registro[key], key, {
            registro,
            stopOnError
         });
         if (esFuncion(onItemValidado)) {
            onItemValidado(resValidacionItem, key);
         }
         if (resValidacionItem.existeError) {
            resValidacionRegistro.existeError = true;
            resValidacionRegistro.msg = 'Se encontraron errores al aplicar las validaciones';
            resValidacionRegistro.data.push(resValidacionItem);
            if (stopOnError) {
               break;
            }
         }
      }
      return resValidacionRegistro;
   }
}
